<template>
  <ion-page class="essay-generate flex-column align-center" :class="aiTheme">
    <!--喇叭表情-->
    <div v-if="baseData.currentEnc === 'trumpet'" class="trumpet-emoji flex-row align-center">
      <img
        class="trumpet-emoji_left mr-3"
        :src="getBrandImageUrl('ai_smart_reading/trumpet_emoji.png')"
        alt=""
      />
      <div class="trumpet-emoji_right flex-column">
        <img
          class="trumpet-emoji_nice mb-3"
          :src="getBrandImageUrl('ai_smart_reading/nice_emoji.png')"
          alt=""
        />
        <img
          class="trumpet-emoji_zh flex-shrink-0"
          :src="getBrandImageUrl('ai_smart_reading/zh_emoji.png')"
          alt=""
        />
      </div>
    </div>
    <!--撒花表情-->
    <div v-if="baseData.currentEnc === 'fireworks'" class="fireworks-emoji">
      <img
        class="fireworks-image"
        :src="getBrandImageUrl('ai_smart_reading/fireworks_emoji.png')"
        alt=""
      />
    </div>
    <!--鼓掌表情-->
    <div v-if="baseData.currentEnc === 'applaud'" class="fireworks-emoji">
      <img
        class="applaud-image"
        :src="getBrandImageUrl('ai_smart_reading/applaud_emoji.png')"
        alt=""
      />
    </div>

    <page-white-background
      :router-type="'modal'"
      title=""
      has-title="essayGenerate"
      @router-back="navigateBackLastPage"
    >
      <template #noTitleContent>
        <!--标题 & 返回按钮 & 右上角参数图标-->
        <div class="right-bar essay-generate_header flex-row justify-end flex-shrink-0">
          <div
            v-if="props.fromPrepareOrigin"
            class="flex-column align-center justify-center mr-3"
            @click="changeReadingPrepare"
          >
            <i class="iconfont icon-yuedulijie right-bar_icon cursor-pointer"></i>
            <span class="operate-text">完型备课</span>
          </div>
          <ThemeTag></ThemeTag>
          <SizeTag v-model="fontStyle"></SizeTag>
          <div
            v-if="!props.fromPrepareOrigin"
            class="flex-column align-center justify-center ml-3"
            @click="openNine"
          >
            <i class="iconfont icon-jiugongge right-bar_icon cursor-pointer"></i>
            <span class="operate-text">九阶岛</span>
          </div>
          <div
            v-if="currentStepStore?.currentStep === 3"
            class="flex-column align-center justify-center ml-3"
            @click="openEssayRelatedModal"
          >
            <i class="iconfont icon-shengciben right-bar_icon cursor-pointer"></i>
            <span class="operate-text">生词本</span>
          </div>
          <div
            v-if="[4].includes(currentStepStore?.currentStep)"
            class="flex-column align-center justify-center ml-3"
            @click="showTranslations"
          >
            <i class="iconfont icon-fanyi right-bar_icon cursor-pointer"></i>
            <span class="operate-text">翻译</span>
          </div>
          <div class="flex-column align-center justify-center ml-3" @click="addThumbTackToContent">
            <i class="iconfont icon-biaoji right-bar_icon cursor-pointer"></i>
            <span class="operate-text">标记</span>
          </div>
          <div class="flex-column align-center justify-center ml-3" @click="highlightSentence">
            <i class="iconfont icon-zidong right-bar_icon cursor-pointer"></i>
            <span class="operate-text">自动</span>
          </div>

          <!--鼓励操作-->
          <div class="encourage">
            <div class="flex-column align-center justify-center ml-3" @click="clickEncourageButton">
              <i class="iconfont icon-guli right-bar_icon cursor-pointer"></i>
              <span class="operate-text">鼓励</span>
            </div>
          </div>
        </div>
      </template>
      <template #default>
        <div class="essay-generate_main flex-column">
          <!--markdown文章-->
          <div
            class="main-content"
            :class="{
              'fullscreen-height': isFullscreen,
              'answer-main-content': [2, 5, 7].includes(currentStepStore?.currentStep),
            }"
          >
            <!--暂停播放-->
            <p v-if="audioStatus === 'playing'" class="audio-play" @click="fullTextAudioStop">
              <i class="iconfont icon-zanting"></i>
            </p>
            <!--播放全文-->
            <p v-else class="audio-play" @click="allSentenceAudioPlay">
              <i class="iconfont icon-bofang3"></i>
            </p>
            <div
              class="essay-generate_content ctt-mp"
              :class="{ 'fold-ctt-mp': modalIsFold === 'fold' }"
            >
              <div class="essay-place flex-row">
                <div class="essay-place_content flex-row">
                  <TextComponent
                    ref="textComponent"
                    :style="fontStyle"
                    :as-raw-text="false"
                    :inversion="false"
                    :article-content="articleContent"
                    :show="true"
                    :learn-type="learnType"
                    :font-style="fontStyle"
                    :from-prepare-origin="props.fromPrepareOrigin"
                    @clickSentenceEvent="clickSentenceEvent"
                  ></TextComponent>
                </div>
              </div>
            </div>
          </div>
          <div class="process flex-column mt-1">
            <img
              class="dropdown-arrow"
              :class="{ 'fold-content': modalIsFold === 'fold' }"
              :src="getBrandImageUrl('ai_smart_reading/down_arrow_icon.svg')"
              alt=""
              @click="closeHalfModal"
            />
            <div
              v-if="
                [2, 3, 5, 6, 7, 8, 9, 10].includes(currentStepStore?.currentStep) &&
                modalIsFold !== 'fold'
              "
              class="full-screen cursor-pointer"
            >
              <i
                v-show="!isFullscreen"
                class="iconfont icon-quanping"
                @click="openModalFullScreen"
              ></i>
              <i
                v-show="isFullscreen"
                class="iconfont icon-quxiaoquanping"
                @click="closeModalHalfScreen"
              ></i>
            </div>
            <div v-if="currentStepStore?.currentStep === 5" class="control-paragraph">
              <img
                v-if="currentParagraphIndex > 1"
                :src="getBrandImageUrl('ai_smart_reading/up_icon.svg')"
                alt="上一段"
                @click.stop="changeParagraph('up')"
              />
              <img
                v-if="currentParagraphIndex < paragraphListLength"
                :src="getBrandImageUrl('ai_smart_reading/down_icon.svg')"
                alt="下一段"
                @click.stop="changeParagraph('down')"
              />
            </div>
            <!--流程内容-->
            <div
              class="expand-content flex-column align-center"
              :class="{
                'fold-content': modalIsFold === 'fold',
                'fullscreen-content': isFullscreen,
                'answer-expand-content': [2, 5, 7].includes(currentStepStore?.currentStep),
                'knowledge-expand-content': [5].includes(currentStepStore.currentStep),
              }"
            >
              <div class="essay-generate_content">
                <div class="essay-place flex-row">
                  <div class="essay-place_content flex-row">
                    <ArticleModal
                      v-model:exercise-obj="articleData"
                      :style="fontStyle"
                      :reading-id="props.readingId"
                      :is-fullscreen="isFullscreen"
                      :from-prepare-origin="props.fromPrepareOrigin"
                      @close-current-half-modal="closeHalfModal"
                      @open-modal-full-screen="openModalFullScreen"
                      @close-modal-half-screen="closeModalHalfScreen"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--进度条 & 鼓励按钮-->
          <div class="essay-generate_bottom flex-row">
            <ArticleProgress
              v-model:exercise-obj="articleData"
              :btn-disabled="btnDisabled"
              :modal-is-fold="modalIsFold"
              :audio-player="audioPlayer"
              :reading-id="props.readingId"
              :word-count="wordCount"
              :from-prepare-origin="props.fromPrepareOrigin"
              @get-current-step="getCurrentStep"
              @click-progress-title="clickProgressTitle"
              @open-current-half-page="openHalfModal"
              @close-current-half-modal="closeHalfModal"
              @hide-all-audio-icon="hideAllSentenceAudioIcon"
              @pause-audio-player="fullTextAudioStop"
            />
          </div>
        </div>
      </template>
    </page-white-background>
  </ion-page>
</template>

<script lang="ts">
/* eslint-disable */
import {
  defineComponent,
  getCurrentInstance,
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  ref,
} from "vue"
import { IonPage } from "@ionic/vue"
import TextComponent from "@/components/MarkdownText.vue"
import Nine from "@/views/speed/Nine.vue"
import ArticleModal from "@/views/reading/newReadingArticle/ArticleModal.vue"
import { useRoute, useRouter } from "vue-router"
import { useExerciseCountdownStore } from "@/hooks/useExerciseCountdown"
import { useCurrentStepStore } from "@/hooks/useCurrentStepStore"
import { useEssayGenerateContentStore } from "@/hooks/useEssayGenerateContentStore"
import store from "@/js/store"
import { useClassEndCountdown } from "@/hooks/useClassEndCountdown"

let that: any
export default defineComponent({
  components: { ArticleModal, TextComponent, IonPage },
  beforeCreate() {
    that = this
  },
})
</script>

<script setup lang="ts">
import { getLocalStorage, localStorageContent } from "@/views/AIGenerate/smartReading/commonMethod"
import { showLoading } from "@/views/AIGenerate/openModal"
import http from "@/js/http"
import { IonContent, IonIcon, modalController, popoverController } from "@ionic/vue"
import { toggleOutline} from "ionicons/icons";
import EssayGeneratePopover from "./ArticlePopover.vue"
import ArticleProgress from "@/views/reading/newReadingArticle/ArticleProgress.vue"
import PageWhiteBackground from "@/components/PageWhiteBackground.vue"
import { computed, nextTick, reactive, watch, withDefaults, defineProps } from "vue"
import { useStorage } from "@vueuse/core"
import ThemeTag from "@/views/AIGenerate/smartReading/components/ThemeTag/ThemeTag.vue"
import { useGlossaryStore } from "@/hooks/useGlossary"
import AIGenerate from "@/views/AIGenerate/AIGenerate.vue"
import { audioPlayStream } from "@/js/common"
import SmartAnalysis from "@/views/AIGenerate/smartAnalysis/smartAnalysis.vue"
import SmartEssay from "@/views/AIGenerate/smartEssay/smartEssay.vue"

import { getArticleDetail } from "@/views/reading/newReadingArticle/components/articleMethod"
import dayjs from "dayjs"
import { getBrandImageUrl } from "@/js/brandImages"
import { textToPlayAudio } from "@/js/textToPlayAudio"
import { useDebounceFn } from "@vueuse/core"
import KeywordPopover from "@/views/reading/newReadingArticle/components/KeywordPopover.vue"
import SizeTag from "@/views/AIGenerate/smartReading/components/SizeTag/SizeTag.vue"
import ReadingPrepare from "@/views/reading/ReadingPrepare.vue"
import store from "@/js/store"
const thumbTackIcon = getBrandImageUrl("ai_smart_reading/thumb_tack.png")
const wordCountIcon = getBrandImageUrl("ai_smart_reading/word_count_icon.svg")
const analysisIcon = getBrandImageUrl("ai_smart_reading/analysis_icon.svg")
const essayIcon = getBrandImageUrl("ai_smart_reading/essay_icon.svg")
const props = withDefaults(
  defineProps<{
    readingId: string
    fromPrepareOrigin: boolean,
    readType:number,
  }>(),
  {
    readingId: "",
    fromPrepareOrigin: false,
    readType:0,
  }
)
const ossUrl = store.getOEMBASE() + "audio-test/temp/"
const learnType = ref()
const route = useRoute()
const router = useRouter()
const countdownStore = useExerciseCountdownStore()
const currentStepStore = useCurrentStepStore()
const glossaryStore = useGlossaryStore()
const contentStore = useEssayGenerateContentStore()
const classCountdown = useClassEndCountdown()
const articleContent = ref("")
const timer = ref()
const gptStr = ref("")
const studentInfo = ref()
const modalIsFold = ref("fold")
const fontSize = ref("小")
const ossAudioPlayer = ref()
const fontStyle = ref({
  "--inherit-size": "3.8vmin",
  "line-height": "1.5rem",
  "--modal-line-height": "2rem",
  "--paragraph-margin": "0 0 1.5rem 0",
})
const selectOptionsVisible = ref(false)
const baseData = reactive({
  currentEnc: "", // 当前鼓励操作
  emojiTimer: null,
  encButtonsVisible: false, // 鼓励是否收起 false 收起 true 展示
})
const exerciseObj = ref<any>({})
const textComponent = ref()
const instance = getCurrentInstance()
const aiTheme = useStorage("ai-theme", "brown", localStorage)
const isFullscreen = ref(false)
const audioPlayer = ref()
const isAddThumbTack = ref(false)
const glossaryList = useStorage("GLOSSARY_ARRAY", [], localStorage)
const openaiAudioPlayer = ref()
const audioMediaType = ref()
const currentParagraphIndex = ref(0)
const bofangTimer = ref(0)
const bofangIcon = ref("icon-bofang3")
const currentBofangClass = ref()
const wordArr = ref<string[]>([])
const articleData = ref({})
const wordIndex = ref(1)
const paragraphListLength = ref(0)
const audioStatus = ref("")
const wordCount = ref(0)
const btnDisabled = ref(true)

function changeParagraph(control: string, index?: number) {
  const paragraph = document.getElementsByClassName("ai-article-paragraph")
  if (index) {
    currentParagraphIndex.value = index
  } else {
    if (control === "up") {
      currentParagraphIndex.value--
    } else {
      currentParagraphIndex.value++
    }
  }
  const target = paragraph[currentParagraphIndex.value - 1]

  const audioDomList = target.querySelectorAll("#ai-sentence-audio")
  const audioDom = audioDomList[audioDomList.length - 1] // 播放icon
  const essayIconDom = target.querySelector(".essay-icon")
  hideAllAudioIcon()
  hideAllEssayIcon()
  audioDom?.classList.remove("sentence-paraphrase-hidden")
  essayIconDom?.classList.remove("sentence-paraphrase-hidden")
  target.classList.add("ai-article-highlight") // 添加高亮
  nextTick(() => {
    target.scrollIntoView()
  })
  handleEvent(null, target?.innerText, currentParagraphIndex.value + "")
}

function ossAudioPlayController(text: string) {
  textToPlayAudio(text, (url: string) => {
    let num = 0
    if (ossAudioPlayer.value?.pause) {
      ossAudioPlayer.value?.pause()
    }
    ossAudioPlayer.value = new Audio(url)
    ossAudioPlayer.value.oncanplay = function () {
      ossAudioPlayer.value.play()
    }
    ossAudioPlayer.value.onended = function () {
      console.log("ended")
      audioStatus.value = "end"
      setElementClass("icon-duanlabofang3")
      clearInterval(bofangTimer.value)
    }
    ossAudioPlayer.value.oncanplaythrough = () => {
      console.log("loading")
      clearInterval(bofangTimer.value)
      audioStatus.value = "playing"
      bofangTimer.value = window.setInterval(() => {
        num = ++num % 3
        bofangIcon.value = `icon-duanlabofang${num + 1}`
        setElementClass(`icon-duanlabofang${num + 1}`)
      }, 300)
    }
  })
  // const ossAudio = ossUrl + ossSuffix + ".mp3";
}

function openModalFullScreen() {
  isFullscreen.value = true
}

function closeModalHalfScreen() {
  isFullscreen.value = false
}

function clickSentenceEvent(e: any) {
  let target = e.target
  if (target) {
    if (currentStepStore.currentStep === 10) {
      if (target.className === "ai-word-single") {
        target = target.parentElement
        if (target.className === "ai-sentence-strong") {
          target = target.parentElement
        }
        if (!target.className.includes("ai-article-small-sentence")) {
          return
        }
      } else if (target.className === "ai-article-small-sentence") {
      } else if (target.className === "ai-sentence-strong") {
        target = target.parentElement
      } else {
        return
      }
      const parentDom = target.parentElement.parentElement.parentElement
      const smallContent = parentDom.querySelectorAll(".ai-article-small-sentence")
      smallContent.forEach((item: any) => {
        item.classList.remove("ai-article-highlight")
      })
      let txt = target.innerText
      if (txt.split(" ").filter((i: string) => !!i).length < 2 && txt.slice(-1) === ",") {
        const broTarget = target.nextElementSibling
        target.classList.add("ai-article-highlight")
        broTarget.classList.add("ai-article-highlight")
        txt += broTarget.innerText
        // audioPlay("text", txt ?? "");
      } else {
        target.classList.add("ai-article-highlight")
        // audioPlay("text", txt ?? "");
      }
    }
    if (currentStepStore.currentStep === 6) {
      openHalfModal()
    }
    // 段落大意
    if (currentStepStore.currentStep === 5) {
      if (target.className === "ai-word-single") {
        if (target.parentElement.className.includes("ai-article-title")) {
          return
        }
        // 单词
        target = target?.parentElement.parentElement.parentElement
      } else if (target.className === "ai-article-sentence") {
        target = target.parentElement
      } else if (
        [
          "markdown-body",
          "ai-essay-tip__date",
          "ai-essay-tip",
          "ai-essay-tip__icon",
          "ai-essay-tip__count",
          "ai-essay-tip__info",
        ].includes(target.className)
      ) {
        return
      } else if (target.className === "ai-article-small-sentence") {
        target = target.parentElement.parentElement
      } else if (target.className === "ai-thumb-tack") {
        target = target.parentElement?.parentElement
      }

      if (target.className.includes("ai-article-title")) {
        return
      }
      if (target.id === "ai-sentence-audio") {
        currentBofangClass.value = target.dataset.id
        const txtDom = target.parentElement
        // ossAudioPlayController(txtDom.getAttribute("paragraph"));
        // audioPlay("text", txtDom.innerText);
        const sentenceList = txtDom.querySelectorAll(".ai-article-sentence")
        console.log("段落大意播放")
        fullTextAudioPlay(sentenceList)
        // ossAudioPlayController(txtDom.innerText);
        return
      }
      if (target.className.includes("essay-icon")) {
        const parentEl = target.parentElement
        gotoEssay(parentEl?.innerText)
        return
      }
      const audioDomList = target.querySelectorAll("#ai-sentence-audio")
      const audioDom = audioDomList[audioDomList.length - 1] // 播放icon
      const essayIconDom = target.querySelector(".essay-icon")
      hideAllAudioIcon()
      hideAllEssayIcon()
      audioDom.classList.remove("sentence-paraphrase-hidden")
      essayIconDom?.classList.remove("sentence-paraphrase-hidden")
      target.classList.add("ai-article-highlight") // 添加高亮

      if (target.getAttribute("paragraph") && target.getAttribute("paragraph") !== "0") {
        currentParagraphIndex.value = +target.getAttribute("paragraph")
        handleEvent(e, target.innerText, target.getAttribute("paragraph"))
      }
    }

    // 挑选生词
    if (currentStepStore.currentStep === 3) {
      if (target.parentElement.className.includes("keyword-content")) {
        target.parentElement.classList.add("ai-article-highlight")
        handleEvent(e, target.innerText)
      } else {
        if (target.className === "ai-word-single") {
          target.classList.add("ai-article-highlight")
          handleEvent(e, target.innerText)
        }
      }
    }

    // 逐句翻译
    if (currentStepStore.currentStep === 4) {
      if (target.className === "ai-word-single") {
        target = target.parentElement.parentElement
      } else if (
        target.className === "ai-article-paragraph" ||
        target.className === "markdown-body"
      ) {
        return
      }
      if (target.className === "ai-article-small-sentence") {
        target = target.parentElement
      }
      if (target.className === "ai-sentence-strong") {
        target = target.parentElement.parentElement
      }

      if (target?.id === "ai-sentence-audio") {
        // 重置上一句播放内容的播放样式
        setElementClass("icon-duanlabofang3")
        currentBofangClass.value = target?.dataset?.id
        const parentDom = target.parentElement.parentElement
        const sentenceDom = parentDom.querySelectorAll(".ai-article-sentence")
        const paraphraseDom = parentDom.querySelectorAll(".ai-sentence-paraphrase")
        const txtDom = target.parentElement
        const parentEl = txtDom.cloneNode(true)
        const lasChild = parentEl.lastChild
        parentEl.removeChild(lasChild) // 删除最后一个元素
        const lastTxt = parentEl?.innerText
        // const idList = currentBofangClass.value.split("-");
        // const ossSuffix = idList.slice(3).join("-");
        // ossAudioPlayController(ossSuffix);
        // 翻译和句子是否一一对应
        if (sentenceDom.length === paraphraseDom.length) {
          console.log(lastTxt.replace(/[\u4e00-\u9fa5]/g, ""))

          ossAudioPlayController(lastTxt)
          // audioPlay("text", lastTxt ?? "");
        } else {
          let firstTxt = ""
          for (var i = 0; i < sentenceDom.length - 1; i++) {
            firstTxt += sentenceDom[i].innerText
          }
          const txt = firstTxt + lastTxt
          ossAudioPlayController(txt)
          // audioPlay("text", txt ?? "");
        }
        console.log("逐句翻译播放")
        return
      }

      if (target.className.includes("analysis-icon")) {
        const parentEl = target.parentElement.cloneNode(true)
        const lasChild = parentEl.lastChild
        parentEl.removeChild(lasChild)
        gotoAnalysis(parentEl?.innerText)
        return
      }
      if (!target) {
        return
      }

      //翻译

      const parentDom = target.parentElement
      const sentenceDomList = parentDom.querySelectorAll(".ai-article-sentence")
      const paraphraseDomList = parentDom.querySelectorAll(".ai-sentence-paraphrase")
      // 翻译和句子不是一一对应的情况
      if (
        target.className === "ai-article-sentence" &&
        sentenceDomList.length !== paraphraseDomList.length
      ) {
        const lastTarget = sentenceDomList[sentenceDomList.length - 1]
        const lastParaphraseDom = lastTarget.lastChild
        const audioDom = lastTarget.querySelector("#ai-sentence-audio")
        const analysisIconDom = lastTarget.querySelector(".analysis-icon")
        if (lastParaphraseDom.style.display === "none") {
          hideAllParaphrase()
          hideAllAnalysisIcon()
          sentenceDomList.forEach((item: any) => {
            item.style.backgroundColor = "var(--text-highlight-color, #262626)"
            item.style.color = "var(--text-clicked-color)"
          })
          audioDom.classList.remove("sentence-paraphrase-hidden")
          analysisIconDom.classList.remove("sentence-paraphrase-hidden")
          lastParaphraseDom.style.display = "block"
        } else {
          sentenceDomList.forEach((item: any) => {
            item.style.backgroundColor = "transparent"
          })
          audioDom.classList.add("sentence-paraphrase-hidden")
          analysisIconDom.classList.add("sentence-paraphrase-hidden")
          lastParaphraseDom.style.display = "none"
        }
        // 翻译和句子一一对应的情况
      } else {
        const paraphraseDom = target.lastChild
        if (paraphraseDom.className === "ai-sentence-paraphrase") {
          const audioDom = target.querySelector("#ai-sentence-audio")
          const analysisIconDom = target.querySelector(".analysis-icon")
          if (paraphraseDom.style.display === "none") {
            hideAllParaphrase()
            hideAllAnalysisIcon()
            target.style.backgroundColor = "var(--text-highlight-color, #262626)"
            target.style.color = "var(--text-clicked-color)"
            audioDom.classList.remove("sentence-paraphrase-hidden")
            analysisIconDom.classList.remove("sentence-paraphrase-hidden")
            paraphraseDom.style.display = "block"
          } else {
            target.style.backgroundColor = "transparent"
            audioDom.classList.add("sentence-paraphrase-hidden")
            analysisIconDom.classList.add("sentence-paraphrase-hidden")
            paraphraseDom.style.display = "none"
          }
        }
      }
    }
  }
}

async function gotoAnalysis(value: string) {
  const modal = await modalController.create({
    component: SmartAnalysis,
    componentProps: { question: value },
    backdropDismiss: false,
    cssClass: "modal_controller_class",
  })
  await modal.present()
  const { data } = await modal.onDidDismiss()
  if ("cancel" === data) {
    await modal.dismiss()
  }
}

async function gotoEssay(value: string) {
  const modal = await modalController.create({
    component: SmartEssay,
    componentProps: { question: value },
    backdropDismiss: false,
    cssClass: "modal_controller_class",
  })
  await modal.present()
  const { data } = await modal.onDidDismiss()
  if ("cancel" === data) {
    await modal.dismiss()
  }
}

function changeFontSize() {
  selectOptionsVisible.value = !selectOptionsVisible.value
}

function initAudioPlayerAndPlay(audioTxt: any, playType?: string) {
  if (
    !audioStatus.value ||
    audioStatus.value === "end" ||
    (playType === "text" && ["playing", "stop"].includes(audioStatus.value))
  ) {
    audioStop()
    fullTextAudioStop()
    audioPlayStream(audioTxt, (callbackData: any, mediaType: string) => {
      audioMediaType.value = mediaType
      let num = 0
      if (mediaType === "MEDIA_SOURCE") {
        openaiAudioPlayer.value = new Audio(callbackData)
        openaiAudioPlayer.value.oncanplay = function () {
          openaiAudioPlayer.value.play()
        }
        openaiAudioPlayer.value.onended = function () {
          console.log("ended")
          audioStatus.value = "end"
          setElementClass("icon-duanlabofang3")
          clearInterval(bofangTimer.value)
        }
        openaiAudioPlayer.value.oncanplaythrough = () => {
          console.log("loading")
          clearInterval(bofangTimer.value)
          audioStatus.value = "playing"
          bofangTimer.value = window.setInterval(() => {
            num = ++num % 3
            bofangIcon.value = `icon-duanlabofang${num + 1}`
            setElementClass(`icon-duanlabofang${num + 1}`)
          }, 300)
        }
      } else if (mediaType === "AUDIO_CONTEXT") {
        openaiAudioPlayer.value = callbackData
        audioStatus.value = "playing"
      }
    })
  }
  if (audioStatus.value === "stop") {
    if (openaiAudioPlayer.value) {
      openaiAudioPlayer.value.play()
      audioStatus.value = "playing"
    }
  }
}

// 设置播放按钮元素类名
function setElementClass(value: string) {
  const el = document.querySelector(`[data-id="${currentBofangClass.value}"]`)
  const classList = el?.classList
  classList?.remove("icon-duanlabofang3", "icon-duanlabofang2", "icon-duanlabofang1")
  classList?.add(value)
}

function audioStop(status?: string) {
  // const status = audioPlayer.value.status
  // if (status === 'play') {
  //   audioPlayer.value.stop()
  // }
  console.log("stop:", status)
  if (audioMediaType.value === "MEDIA_SOURCE") {
    if (openaiAudioPlayer.value?.pause) {
      openaiAudioPlayer.value.pause()
      audioStatus.value = status ? status : "end"
    }
  } else if (audioMediaType.value === "AUDIO_CONTEXT") {
    if (openaiAudioPlayer.value) {
      openaiAudioPlayer.value.close()
      audioStatus.value = status ? status : "end"
    }
  }
  setElementClass("icon-duanlabofang3")
  clearInterval(bofangTimer.value)
}

const allSentenceAudioPlay = useDebounceFn(() => {
  const sentenceList = document.querySelectorAll(".ai-article-sentence")
  fullTextAudioPlay(sentenceList, "fullParaphrase")
}, 500)

function fullTextAudioPlay(sentenceList: any, from?: string) {
  // const paragraphList = document.querySelectorAll(".ai-article-paragraph[paragraph]");
  if (sentenceList.length > 0) {
    let currentIdx = 0
    const paragraphAudioPlay = () => {
      const dom = sentenceList[currentIdx]
      let text = ""
      for (const child of dom.childNodes) {
        if (
          child.nodeType === Node.TEXT_NODE ||
          (child.nodeType === Node.ELEMENT_NODE &&
            !child.classList.contains("ai-sentence-paraphrase"))
        ) {
          text += child.textContent
        }
      }

      textToPlayAudio(text.trim(), (url: string) => {
        let num = 0
        fullTextAudioStop()
        ossAudioPlayer.value = new Audio(url)
        ossAudioPlayer.value.oncanplay = function () {
          audioStatus.value = "playing"
          ossAudioPlayer.value.play()
        }
        ossAudioPlayer.value.oncanplaythrough = () => {
          clearInterval(bofangTimer.value)
          audioStatus.value = "playing"
          if (from !== "fullParaphrase") {
            bofangTimer.value = window.setInterval(() => {
              num = ++num % 3
              bofangIcon.value = `icon-duanlabofang${num + 1}`
              setElementClass(`icon-duanlabofang${num + 1}`)
            }, 300)
          }
        }
        ossAudioPlayer.value.onended = function () {
          if (currentIdx === sentenceList.length - 1) {
            audioStatus.value = "end"
            fullTextAudioStop()
          } else {
            currentIdx += 1
            paragraphAudioPlay()
          }
        }
      })
    }
    paragraphAudioPlay()
  }
}

function fullTextAudioStop() {
  if (ossAudioPlayer.value?.pause) {
    ossAudioPlayer.value.pause()
  }
  audioStatus.value = "end"
  setElementClass("icon-duanlabofang3")
  clearInterval(bofangTimer.value)
}

function audioPlay(playType?: string, playText?: string) {
  let audioTxt = playText?.replace(/[\u4e00-\u9fa5]/g, "")

  if (playType !== "text") {
    audioTxt = articleData.value?.essayContent.replace(/[\u4e00-\u9fa5]/g, "")
  }
  initAudioPlayerAndPlay(audioTxt, playType)
}

function hideAllSentenceAudioIcon() {
  const audioIconArr = document.querySelectorAll("#ai-sentence-audio")
  if (audioIconArr) {
    audioIconArr.forEach((el: any) => {
      el.classList.add("sentence-paraphrase-hidden")
      // el.parentElement.style.backgroundColor = 'transparent'
    })
  }
}

function hideAllParaphrase(): void {
  const paragraphArr = document.querySelectorAll(".ai-sentence-paraphrase")
  if (paragraphArr) {
    paragraphArr.forEach((el: any) => {
      el.style.display = "none"
      el.parentElement.style.backgroundColor = "transparent"
    })
  }
  hideAllSentenceAudioIcon()
  hideAllAnalysisIcon()
}

function hideAllAudioIcon() {
  const audioDomArr = document.querySelectorAll("#ai-sentence-audio")
  if (audioDomArr) {
    audioDomArr.forEach((el: any) => {
      el.classList.add("sentence-paraphrase-hidden")
    })
  }
}

function hideAllAnalysisIcon() {
  const DomArr = document.querySelectorAll(".analysis-icon")
  if (DomArr) {
    DomArr.forEach((el: any) => {
      el.classList.add("sentence-paraphrase-hidden")
    })
  }
}

function hideAllEssayIcon() {
  const DomArr = document.querySelectorAll(".essay-icon")
  if (DomArr) {
    DomArr.forEach((el: any) => {
      el.classList.add("sentence-paraphrase-hidden")
    })
  }
}

function showAllParaphrase(): void {
  const elements = document.querySelectorAll(".ai-sentence-paraphrase")

  if (elements) {
    elements.forEach((el: any) => {
      el.style.display = "block"
      const audioDom = el.parentElement.querySelector("#ai-sentence-audio")
      const analysisIconDom = el.parentElement.querySelector(".analysis-icon")
      audioDom.classList.remove("sentence-paraphrase-hidden")
      analysisIconDom.classList.remove("sentence-paraphrase-hidden")
    })
  }
}

//取消所有句子高亮
function cancelAllSentenceHightlight(): void {
  const elements = document.querySelectorAll(".ai-article-sentence")
  if (elements) {
    elements.forEach((el: any) => {
      el.style.backgroundColor = "transparent"
    })
  }
}

//句子翻译
function showTranslations() {
  //获取所有的英文句子dom元素
  const sentences = document.querySelectorAll(".ai-article-sentence")
  if (sentences) {
    //用于控制展示全部翻译或隐藏全部翻译
    let displayAllSwitch = false

    //遍历所有的句子，找出子元素中没有翻译的句子
    //用于判断是展示全部或隐藏全部
    sentences.forEach((el: any) => {
      //取消所有句子高亮
      cancelAllSentenceHightlight()
      hideAllAnalysisIcon()
      hideAllAudioIcon()
      //只要有一个，没有翻译，则全部展示
      let ell = el.querySelector(".ai-sentence-paraphrase")
      if (ell && ell.style.display === "none") {
        displayAllSwitch = true
      }
    })

    if (displayAllSwitch) {
      showAllParaphrase()
    } else {
      hideAllParaphrase()
    }
  }
}

function addThumbTackToContent() {
  isAddThumbTack.value = !isAddThumbTack.value

  let domArr: any = document.querySelectorAll(".ai-thumb-tack")

  if (domArr) {
    for (let i = 0; i < domArr.length; i++) {
      if (isAddThumbTack.value) {
        domArr[i].classList.remove("sentence-paraphrase-hidden")
      } else {
        domArr[i].classList.add("sentence-paraphrase-hidden")
      }
    }
  }
}

// 自动选择句子功能
let autoIndex = -1

function changeAutoIndex(domArr: any[]) {
  if (autoIndex < domArr.length - 1) {
    autoIndex++
  } else {
    autoIndex = 0
  }
}

function highlightSentence(type?: string) {
  let domArr: any = document.querySelectorAll(".ai-article-sentence")

  if (domArr) {
    if (type !== "clear") {
      changeAutoIndex(domArr)
    }

    for (let i = 0; i < domArr.length; i++) {
      if (i === autoIndex) {
        domArr[i].style.backgroundColor = "rgba(24,126,246,0.2)"
        if (!isInViewport(domArr[i])) {
          nextTick(() => {
            domArr[i].scrollIntoView()
          })
        }
      } else {
        domArr[i].style.backgroundColor = "transparent"
      }
    }
  }
}

function isInViewport(element: HTMLElement) {
  const rect = element.getBoundingClientRect()
  const box = document.querySelector(".essay-generate_content")
  console.dir(box)
  return (
    rect.top < (box?.scrollTop ?? 0) + (box?.clientHeight ?? 0) && rect.top > (box?.scrollTop ?? 0)
  )
}

const audio = ref()
const audioTime = [2000, 2000, 3000]

function clickEncourageButton() {
  if (baseData.emojiTimer) clearTimeout(baseData.emojiTimer)

  const randomIndex = (Math.random() * 3) | 0
  baseData.currentEnc = ["trumpet", "fireworks", "applaud"][randomIndex]
  encourageAudioPlay()
  baseData.emojiTimer = setTimeout(() => {
    baseData.currentEnc = ""
    audioPause()
  }, audioTime[randomIndex]) as any
}

function encourageAudioPlay() {
  audioPause()
  const audioUrl = `/assets/audio/${baseData.currentEnc}.mp3`
  audio.value = new Audio(audioUrl)
  audio.value.play()
}

function audioPause() {
  if (audio.value) {
    audio.value.pause()
  }
}

//取消点击内容高亮显示
function cancleHighlight(paragraph?: any): void {
  const highlightDomList = document.querySelectorAll(".ai-article-paragraph")
  for (let i = 0; i < highlightDomList.length; i++) {
    if (paragraph) {
      if (paragraph != i + 1) {
        highlightDomList[i].classList.remove("ai-article-highlight")
      }
    } else {
      highlightDomList[i].classList.remove("ai-article-highlight")
    }
  }
}

async function showPopover(event: any, type: string, content: string, callback?: any) {
  const parentEl = event.target.parentElement
  let descContent = ""
  if (parentEl.getAttribute("desc-content")) {
    descContent = parentEl.getAttribute("desc-content")
  }
  const popover = await popoverController.create({
    component: EssayGeneratePopover,
    componentProps: {
      sentence: content,
      type: type,
      gptStr: gptStr.value ? gptStr.value : "",
      descContent: descContent,
      fromPrepareOrigin: props.fromPrepareOrigin,
    },
    event: event,
    align: "center",
    reference: "event",
    showBackdrop: false,
  })

  await popover.present()
  popover.onDidDismiss().then(async (res) => {
    const highlightDomList = document.querySelectorAll(".ai-article-highlight")
    highlightDomList.forEach((el) => {
      el.classList.remove("ai-article-highlight")
    })
    callback(res)
    if (res.data) {
      if (res.data.status === "关闭AI词典") {
        const modal = await modalController.create({
          component: AIGenerate,
          componentProps: { word: res.data.word },
          cssClass: "modal_controller_class",
        })
        await modal.present()
      }
    }
  })

  cancleHighlight()
}

//关键词短语弹窗
async function showKeywordPopover(event: any) {
  const parentEl = event.target.parentElement
  let descContent = ""
  if (parentEl.getAttribute("desc-content")) {
    descContent = parentEl.getAttribute("desc-content")
  }
  const popover = await popoverController.create({
    component: KeywordPopover,
    componentProps: {
      descContent: descContent,
    },
    event: event,
    align: "center",
    reference: "event",
    showBackdrop: false,
  })
  popover.present()
  popover.onDidDismiss().then(async (res) => {
    parentEl.classList.remove("ai-article-highlight")
  })
  cancleHighlight()
}

function changeFontStyle(size: string) {
  if (size === "小") {
    fontStyle.value = {
      "--inherit-size": "3.8vmin",
      "line-height": "1.5rem",
      "--modal-line-height": "2rem",
      "--paragraph-margin": "0 0 1.5rem 0",
    }
  } else if (size === "中") {
    fontStyle.value = {
      "--inherit-size": "4.5vw",
      "line-height": "2rem",
      "--modal-line-height": "2.5rem",
      "--paragraph-margin": "0 0 2rem 0",
    }
  } else if (size === "大") {
    fontStyle.value = {
      "--inherit-size": "5.5vw",
      "line-height": "2.5rem",
      "--modal-line-height": "3rem",
      "--paragraph-margin": "0 0 2.5rem 0",
    }
  }
  changeFontSize()
}

function changeCourse() {
  return new Promise((resolve, reject) => {
    http
      .post("/course/changeCourseReading", {
        aptmId: store.getAppointment().aptmId,
      })
      .then((res) => {
        if (res.data.success) {
          resolve("success")
        } else {
          reject("")
        }
      })
  })
}

function pauseAudioPlayer() {
  audioStop("stop")
  fullTextAudioStop()
}

//切换到完型备课模式
async function changeReadingPrepare() {
 const modal = await modalController.create({
    component: ReadingPrepare,
    componentProps: { readingId: props.readingId, isReadOrOriginal: true, readType:props.readType },
    cssClass: "modal_controller_class",
  });
  modalController.dismiss()
 await modal.present();
}

//打开9宫格，开始上课
async function openNine() {
  pauseAudioPlayer()
  await changeCourse()
  const appointment = store.getAppointment()
  const modal = await modalController.create({
    component: Nine,
    componentProps: {
      studentId: appointment.studentId,
      readingId: 1,
      classType: "smartReading",
    },
    cssClass: "modal_controller_class",
  })

  modal.onDidDismiss().then((res) => {
    const data = res.data
    if (data?.courseTypeId) {
      if (data.courseTypeId === 16 && data.status === "backAIReading") {
        // 如果是 回到智阅 按钮 则关闭 AI智阅的九阶岛modal
        modalController.dismiss().catch((e) => console.log(e))
      }
    }
  })
  return modal.present()
}

async function navigateBackLastPage() {
  audioStop()
  fullTextAudioStop()
  const appointment = store.getAppointment()
  await http.post("/reading/finishReadingArticleLearning", {
    readingId: appointment.readingId,
    studentId: appointment.studentId,
    aptmId: appointment.aptmId,
  })
  await modalController.dismiss()
}

async function getOmitWordDic() {
  const result = await http.post("/Ai/queryAcronymAll", {})
  if (result.data.code === 200) {
    wordArr.value = result.data.data.map((item: any) => item.acronym.replaceAll(".", "\\."))
    return new RegExp(`\\b(${wordArr.value.join("|")})([^a-zA-Z]|$)`, "g")
  } else {
    return /\b(Mr\.|Mrs\.|Miss\.)([^a-zA-Z]|$)/g
  }
}

function delChineseMark(content: string): string {
  content = content.replaceAll("’", "'")
  content = content.replaceAll("。", ".")
  content = content.replaceAll("，", ",")
  content = content.replaceAll("！", "!")
  content = content.replaceAll("？", "?")
  content = content.replaceAll("；", ";")
  content = content.replaceAll("：", ":")
  return content
}

// 创建单词标签
function createWordStyle(sentence: string) {
  const content = sentence.replace(
    /(?<!<[^>]*?)([a-zA-Z]+)([-'‘’][a-zA-Z]+([-'‘’][a-zA-Z]+)?)?(\.[a-zA-Z]+\.[a-zA-Z]+)?(\.[a-zA-Z]+\.)?/gim,
    (search: string) => {
      wordIndex.value++
      return `<span style="z-index: 100;" class="ai-word-single" id="ai-word-single${wordIndex.value}">${search}</span>`
    }
  )
  return content
}

// 创建标题标签
function createTitleStyle(title: string) {
  const words = articleData.value.essayContent.split(/\s+/).filter((word) => word.length > 0)
  wordCount.value = words.length
  return `<p paragraph="0" class="ai-article-title">${title}</p><div class="ai-essay-tip"><span class="ai-essay-tip__date">${dayjs().format("YYYY-MM-DD")}</span><div class="ai-essay-tip__info"><img src="${wordCountIcon}" class="ai-essay-tip__icon" alt=""><span class="ai-essay-tip__count">${wordCount.value}</span>词</div></div>`
}

function createSmallSentence(sentence: string) {
  let num = 0
  let result = ""
  // 按逗号分句，用于朗读
  //用正则匹配sentence中的指定标点符号进行短句
  result = sentence.replace(
    /(?<!<[^>]*?)([a-zA-Z]+)([-'‘’][a-zA-Z]+)?(\.[a-zA-Z]+\.[a-zA-Z]+)?(\.[a-zA-Z]+\.)/gim,
    (match: string) => {
      if (match && match !== " ") {
        num++
        return `<span class="ai-article-small-sentence">${match}</span>`
      }
    }
  )
  if (num === 0) {
    result = `<span class="ai-article-small-sentence">${sentence}</span>`
  }
  return result
}

// 创建句子标签
function createSentenceStyle(
  sentence: string,
  paragraphNum: number,
  sentenceNum: number,
  translation: string
) {
  return `<span class="ai-article-sentence" paragraph="${paragraphNum}" sentence="${sentenceNum}" id="ai-sentence-${paragraphNum}-${sentenceNum}">${createSmallSentence(sentence)}<img class="ai-thumb-tack sentence-paraphrase-hidden"src="${thumbTackIcon}" alt="" /><i id="ai-sentence-audio" data-id="ai-sentence-audio-${paragraphNum}-${sentenceNum + 1}" class="iconfont icon-duanlabofang3 sentence-paraphrase-hidden"></i><img src='' class="analysis-icon sentence-paraphrase-hidden" /><span class="ai-sentence-paraphrase" style="display: none; color: rgb(151, 152, 156);">${translation}</span></span>`
}

// 创建段落标签
function createParagraphStyle(phragraph: string, paragraphNum: number) {
  return `<p paragraph="${paragraphNum}" class="ai-article-paragraph">${phragraph}<i id="ai-sentence-audio" data-id="ai-sentence-audio-${paragraphNum}" class="iconfont icon-duanlabofang3 sentence-paraphrase-hidden"></i><img src='' class="essay-icon sentence-paraphrase-hidden" /></p>`
}

//处理文章内容样式
async function modifyArticleContentStyle() {
  let content = ""
  content += createTitleStyle(createWordStyle(articleData.value.title))
  const phrasesArr: string[] = []
  // 处理句子
  for (
    let sentenceNum = 0, paragraphNum = 1, i = 0;
    i < articleData.value.phrasesInfoVOList.length;
    i++
  ) {
    const item = articleData.value.phrasesInfoVOList[i]
    // 如果段落数组找到有值
    if (phrasesArr[item.sectionId - 1]) {
      sentenceNum++
      phrasesArr[item.sectionId - 1] += createSentenceStyle(
        createWordStyle(item.content),
        paragraphNum,
        sentenceNum,
        item.translation
      )
    } else {
      paragraphNum = item.sectionId
      sentenceNum = 0
      phrasesArr.push(
        createSentenceStyle(
          createWordStyle(item.content),
          paragraphNum,
          sentenceNum,
          item.translation
        )
      )
    }
  }
  // 处理段落
  phrasesArr.forEach((item: string, index: number) => {
    content += createParagraphStyle(item, index + 1)
  })
  articleContent.value = content
}

function getCurrentStep(index: any) {
  currentStepStore.currentStep = ArticleIndex
}

function isAtAnswerQuestions() {
  countdownStore.startCountdownFun() // 开始倒计时
}

function closeHalfModal() {
  modalIsFold.value = "fold"
  isFullscreen.value = false
}

function openHalfModal() {
  modalIsFold.value = "expand"
  isFullscreen.value = false
}

// 继续答题
async function openEssayRelatedModal() {
  if (currentStepStore.currentStep === 3) {
    await initGlossaryList()
  }

  if (modalIsFold.value === "fold") {
    modalIsFold.value = "expand"
    isFullscreen.value = false
  } else if (modalIsFold.value === "expand") {
    closeHalfModal()
  }
}

function clickProgressTitle() {
  if (currentStepStore.currentStep === 3) {
    initGlossaryList()
  }
  if (modalIsFold.value === "fold") {
    modalIsFold.value = "expand"
    isFullscreen.value = false
    if (currentStepStore.currentStep === 5 && currentParagraphIndex.value === 0) {
      changeParagraph("", 1)
    }
  } else if (modalIsFold.value === "expand") {
    closeHalfModal()
  }
}

function clearAllInterval() {
  countdownStore.clearCountdownInterval()
}

//调用接口进行翻译
async function postTranslation(content: string, paragraph: string, sentence: string) {
  let gtContent = getLocalStorage("GenerateContent", {})
  let readId = gtContent.eduAiAppointmentReadId

  return new Promise(async (resolve: any, reject: any) => {
    const loading = await showLoading("翻译中...")
    try {
      let translateURL = `/Ai/getContentCn?Id=${readId}&paragraph=${paragraph}&sentence=${sentence}`

      //段落
      if (currentStepStore.currentStep === 5) {
        translateURL = `/Ai/getParagraphCn?paragraph=${paragraph}${readId ? "&Id=" + readId : ""}`
      }

      //单词
      else if (currentStepStore.currentStep === 3) {
        closeHalfModal()
        translateURL = `/Ai/getVocabularyCn?word=${content}`
      }

      const resData = await http.get(translateURL)

      if (resData && resData.data && resData.data.data) {
        gptStr.value = resData.data.data
      }

      await loading.dismiss()
      resolve("")
    } catch (e) {
      await loading.dismiss()
      reject("")
      throw e
    }
  })
}

async function handleEvent(ev: any, content: string, paragraph?: string, sentence?: string) {
  const appointment = store.getAppointment()

  //判断是否是关键词短语
  const parentEl = ev ? ev.target.parentElement : null
  const trimmedInnertext = parentEl ? parentEl.innerText.trim() : null
  if (
    parentEl &&
    parentEl.classList.contains("keyword-content") &&
    /\s/.test(trimmedInnertext) &&
    currentStepStore.currentStep === 3
  ) {
    showKeywordPopover(ev)
  } else {
    //调用GPT进行翻译
    postTranslation(content, paragraph, sentence).then(async () => {
      const ctt = content.replace(/[*]{2}(.+?)[*]{2}/gim, ($1, $2: any) => {
        return `<strong class="ai-sentence-strong" style="color: #0BBB7D;text-align: center">${$2}</strong>`
      })
      // 阅读理解学习
      //如果是单词，弹框需要展示【添加生词】按钮
      if (currentStepStore.currentStep === 3) {
        // 点击生词停止播放
        audioStop()
        fullTextAudioStop()
        await showPopover(ev, "word", ctt, (res) => {
          if (res.data && res.data.status === "关闭popover") {
            glossaryList.value.push({ id: ev.target.id, word: ctt })
            ev.target.style.backgroundColor = "var(--glossary-text-bg)"
          }
        })
      }

      //段落
      else if (currentStepStore.currentStep === 5) {
        articleData.value.sentence =
          unlabelSentence(articleData.value.sentencesVOList[+paragraph - 1].paragraphKnowledge) ||
          ""
        openHalfModal()
        cancleHighlight(paragraph)
      } else {
        gptStr.value = ""
      }
    })
  }
}

// 去掉标签
function unlabelSentence(sentence: string) {
  const re = /(?<=<.+>)[\s\S]+?(?=<\/.+>)/g
  const matchResult = sentence
    .match(re)
    ?.map((item) =>
      item
        .replace(/(<.+?>)/g, (val) => (val !== "<br>" ? "" : "<br>"))
        .replace(/&nbsp;/g, "")
        .replace(/\n{2,}|(<br>){2,}/g, "<br>")
        .replace(/\n/g, " ")
        .replace(/^<br>$/g, "")
    )
    ?.filter((i: string) => !!i)
  console.log("matchResult", matchResult)
  return matchResult?.join("\n").replaceAll("<br>", "\n")
}

// 初始化生词本
async function initGlossaryList() {
  const appointment = store.getAppointment()
  glossaryStore.getGlossaryList(appointment.studentId, appointment.courseTypeId)
}

//为每一段落绑定事件
function bindClickEvent() {
  const mdBody = document.querySelector(".markdown-body")
  let n = 0
  if (mdBody) {
    //为段落绑定事件
    mdBody.querySelectorAll("p").forEach((el) => {
      //为段落绑定点击事件
      el.addEventListener("click", (e) => {
        if (currentStepStore.currentStep === 5) {
          console.log("class", el.className)
          if (el.className.includes("ai-article-paragraph")) {
            el.classList.add("ai-article-highlight") // 添加高亮
          } else {
            el.classList.remove("ai-article-highlight")
          }
          // handleEvent(e, el.innerText, el.getAttribute("paragraph") ?? '', undefined)
        }
      })

      let elArr = el.querySelectorAll(".ai-article-sentence")
      for (let i = 0; i < elArr.length; i++) {
        elArr[i].setAttribute("paragraph", el.getAttribute("paragraph") ?? "")
        elArr[i].setAttribute("sentence", String(n))
        n++
      }
    })
  }
}

function modifyGlossaryWordBg() {
  if (glossaryList.value) {
    glossaryList.value.forEach((list) => {
      const wordDom = document.getElementById(list.id)
      if (wordDom && wordDom.innerText === list?.word) {
        wordDom.style.backgroundColor = "rgba(255,173,0,0.5)"
      }
    })
  }
}

// 置顶高度
function resetHeight() {
  const el = document.querySelector(".ai-article-title")
  if (el) {
    el?.scrollIntoView()
  }
}

function saveReadingId() {
  const appointment = store.getAppointment()
  const data = {
    ...appointment,
    readingId: props.readingId,
  }
  store.setAppointment(data)
}

watch(
  () => contentStore.contentObj,
  () => {
    exerciseObj.value = getLocalStorage("GenerateContent", {})
  },
  { deep: true }
)

watch(
  () => currentStepStore.currentStep,
  () => {
    audioStop()
    fullTextAudioStop()
    resetHeight()
    if (autoIndex !== -1) {
      autoIndex = -1
      highlightSentence("clear")
    }
    if (currentStepStore.currentStep === 4) {
      gptStr.value = ""
    }

    // 答题
    if (currentStepStore.currentStep === 2) {
      isAtAnswerQuestions()
    }

    //挑选生词
    if (currentStepStore.currentStep === 3) {
      const keywords = document.querySelectorAll(".keyword-content")
      keywords.forEach((key) => {
        key.classList.add("keyword-content-text")
      })
    } else {
      const keywords = document.querySelectorAll(".keyword-content")
      keywords.forEach((key) => {
        key.classList.remove("keyword-content-text")
      })
    }

    if (currentStepStore.currentStep === 5) {
      currentParagraphIndex.value = 0
    }

    if (currentStepStore.currentStep === 9) {
      const list = document.querySelectorAll(".ai-article-highlight")
      if (list && list.length > 0) {
        list.forEach((item) => {
          item.classList.remove("ai-article-highlight")
        })
      }
    }
  }
)

watch(
  () => articleData.value.btnDisabled,
  () => {
    btnDisabled.value = articleData.value.btnDisabled
  }
)

onBeforeMount(() => {
  // 获取amptId
  localStorageContent("GenerateContent", {})
})

onMounted(async () => {
  saveReadingId()
  const appointment = store.getAppointment()
  currentStepStore.initStepNum()
  articleData.value = await getArticleDetail(props.readingId, appointment.aptmId)

  btnDisabled.value = articleData.value.btnDisabled

  modifyArticleContentStyle()
  paragraphListLength.value = articleData.value?.sentencesVOList?.length ?? 0
  if (!props.fromPrepareOrigin) {
    classCountdown.countdownTimeInterval(that, appointment.aptmId)
  }

  // 初始化 Audio 播放器
  audioPlayer.value = new AudioPlayer("/assets/js")

  setTimeout(() => {
    bindClickEvent()

    modifyGlossaryWordBg()
    // handleArticleParaphrase();
  }, 1000)
})
onBeforeUnmount(() => {
  audioStop()
  fullTextAudioStop()
  clearAllInterval()
  contentStore.clearContent()
  classCountdown.resetClassCountdown()
  localStorage.removeItem("GenerateContent")
})
</script>

<style>
.keyword-content-text {
  text-decoration: underline;
  text-decoration-color: red;
  text-decoration-style: wavy;
  text-decoration-skip-ink: none;
}

.ai-article-sentence-paraphrase {
  font-size: 3vw;
}

.sentence-paraphrase-hidden {
  display: none !important;
}

.ai-thumb-tack {
  width: 2.5vw;
  margin-right: 2vw;
}

.analysis-icon,
.essay-icon {
  width: 1.35rem;
  vertical-align: middle;
  margin-left: 0.2rem;
  cursor: pointer;
}

#ai-sentence-audio {
  font-size: 5vw;
  //text-indent: 2vw;
  color: #ffad00;
  margin-left: 2vw;
  vertical-align: middle;
}
</style>
<style scoped lang="less">
@import "@/assets/common.less";
@import "@/theme/ai-theme.less";

.essay-generate {
  position: relative;
  height: 100%;
  width: 100%;
  //padding-bottom: 3%;

  .fireworks-emoji,
  .trumpet-emoji {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 20;
  }

  ion-content::part(background) {
    background: transparent;
  }

  .operate-text {
    font-size: var(--font-pure-2);
    white-space: nowrap;
    color: var(--icon-color, #262626);
  }

  .right-bar {
    .change-size {
      position: relative;

      .size-popover {
        &::part(content) {
          --box-shadow: 0 0 1px 0 var(--font-grey-color);
          display: flex;
          flex-direction: row;
        }
      }
    }

    .encourage {
      position: relative;

      &-list {
        position: absolute;
        top: 150%;
        left: 10%;
        width: 200%;
        display: flex;

        & > img {
          z-index: 6;
          width: 35%;
          transform: scale(0);
          transform-origin: center center;
          transition: all 0.3s ease-in;
        }

        &::after {
          content: "";
          position: absolute;
          bottom: -10%;
          width: 60%;
          height: 120%;
          background-color: #ffffff;
          border-radius: 5vw;
          z-index: 5;
          transform: scale(0);
          transform-origin: bottom center;
          transition: all 0.3s ease-in;
          box-shadow: 0 0 1px 0 rgba(128, 128, 128, 0.39);
        }
      }

      .active_transition {
        & > img {
          transform: scale(1);
          transition: all 0.3s ease-in;
        }

        &::after {
          transform: scale(1);
          transition: all 0.3s ease-in;
        }
      }
    }

    &_icon {
      font-size: 20px;
      color: var(--icon-color, #262626);
    }
  }

  &_header {
    width: 100%;
    height: 10%;
  }

  &_main {
    width: 100%;
    height: 100%;
  }

  .main-content {
    flex: 1;
    height: calc(100% - 50vh);
    width: 100%;
    border-radius: 3vw;
    background-color: var(--text-background-color, #f8f8f8);
    position: relative;

    .audio-play {
      position: absolute;
      right: 3%;
      top: -0.6rem;
      width: 6%;
      color: var(--text-import-color);

      i {
        font-size: 6vw;
      }
    }
  }

  .answer-main-content {
    height: 0;
  }

  .fullscreen-height {
    height: 0;
  }

  .expand-content {
    height: 50vh;
    width: 100%;
    transition: height 0.3s ease;
    position: relative;
  }

  .answer-expand-content {
    height: auto;
  }

  .knowledge-expand-content {
    max-height: 50vh;
  }

  .fold-content {
    height: 0;
    transition: height 0.3s ease;
  }

  .fullscreen-content {
    height: 85vh;
    max-height: 85vh;
  }

  &_content {
    flex: 1;
    width: 100%;
    height: 100%;
    position: relative;

    &-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 0 5% 5% 5%;
      z-index: -1;
    }

    .essay-place {
      width: 100%;
      height: 100%;
      display: flex;
      overflow-y: auto;
      padding-right: 0.1rem;

      &_content {
        width: 100%;
        //height: 100%;
        //padding: 0 3% 10% 3%;        display: flex;        position: relative;

        .translation-list {
          width: 100%;

          &_item {
            text-indent: 5vw;
            color: var(--text-color, #606266);
            font-size: 3vw;
            line-height: 2rem;
            cursor: pointer;
          }
        }
      }

      .content-padding {
        padding: 5% 3% 10% 3%;
      }
    }
  }

  .ctt-mp {
    height: calc(100% - 2.2rem);
    margin-top: 2.2rem;
    padding: 0 3% 3%;
  }

  .fold-ctt-mp {
    padding: 0 3% 11% 3%;
  }

  &_footer {
    width: 100%;
    color: #606266;
    text-align: right;

    &-create {
      &::part(native) {
        background-color: #0bbb7d;
      }
    }

    &-practice {
      width: 60%;

      &::part(native) {
        background-color: #f8ac17;
        width: 40vw;
      }
    }
  }

  &_bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0 4vw;
    height: 9%;
    z-index: 10;
  }

  .process {
    position: relative;
    background-color: var(--text-background-color, #f8f8f8);
    border-radius: 3vw;
    z-index: 10;

    .dropdown-arrow {
      position: absolute;
      top: 3%;
      left: 50%;
      transform: translate(-50%, 0);
      width: 1rem;
      z-index: 10;
    }

    .full-screen {
      position: absolute;
      right: 1%;
      top: 1.6%;
      z-index: 999;
      display: flex;
      justify-content: flex-end;
      color: var(--text-import-color, --theme-color);

      i {
        font-size: 1.5rem;
      }

      img {
        width: 5vw;
      }
    }

    .control-paragraph {
      position: absolute;
      top: 1.6%;
      left: 1%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 3.8rem;
      z-index: 999;

      & > img {
        width: 1.5rem;
      }
    }
  }
}
</style>
